import IconSVG from 'svg-inline-react'
import {
  APP_URL,
  SEGMENT_ID
} from 'constants/ResourcesConstants'
import makeSegmentSnippet from 'constants/makeSegmentSnippet'
import refreshSrc from '!svg-inline?removeTags=true!images/icons/refresh-icon.svg'

export function newConversation() {
  if (typeof window.drift === 'undefined' || window.drift === null) { return }
  return window.drift.on('ready', api => api.sidebar.open())
}

export function notifyOffline(app) {
  app.actions.NotificationActions.pushNotification({
    content: 'Looks like you’re offline? Just hit refresh when you’re back.',
    sticky: true,
    actioNode: (
      <a href={APP_URL} className="dsg-SmallButton">
        <IconSVG src={refreshSrc}
                 style={{ marginRight: 3, height: 12, width: 12 }}
        />
        Refresh
      </a>
    ),
    variant: 'red'
  })
}

export function notifyOnline(app) {
  app.actions.NotificationActions.pushNotification({
    content: 'You are back online!',
    variant: 'green'
  })
}

export function installSegment() {
  const scriptTag = document.createElement("script")
  scriptTag.id= "segment-container"
  scriptTag.innerHTML = makeSegmentSnippet(SEGMENT_ID)
  document.body.appendChild(scriptTag)
}

export function installWidgetStub() {
  const drift = window.drift = window.driftt = (window.drift || window.driftt || [])

  const methods = ['identify', 'track', 'reset', 'debug', 'show', 'ping', 'page', 'hide', 'off', 'on', 'config', 'setUserJwt', 'waitForUserJwt']
  methods.forEach((key) => {
    if (!drift[key]) {
      drift[key] = (...args) => {
        drift.push([key, ...args])
      }
    }
  })
}

export function hideWelcomeMessage() {
  window.drift.config({
    enableWelcomeMessage: false,
  })
}

export function waitForUserJwt() {
  if (!window.drift) {
    console.warn('widget stub is not installed yet, you need to call installWidgetStub() first')
    return
  }

  window.drift.waitForUserJwt()
}



// WEBPACK FOOTER //
// ./src/scripts/app/Helpers.js